<template>
  <div>
    <div v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;">
      <div>
        <div>
          <h3>{{loader_message}}</h3>
        </div>
      </div>
    </div>
    <div>
      <div class="row align-items-end my-4">
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Start Date</label>
            <input type="date" class="form-control" v-model="start_date" />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Stop Date</label>
            <input type="date" class="form-control" v-model="end_date" />
          </div>
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" v-model="name" placeholder="Search By Name" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <button @click.prevent="getData()" class="button btn">
              <span class="custom-loader" v-if="data_loading">
                <loader-icon size="1.5x" class="custom-class"></loader-icon>
                <span style="font-weight: 600; text-transform: initial;">Please Wait</span>
              </span>
              <span v-else>Submit</span>
            </button>
            <!-- clear button -->
            <button @click.prevent="clearData()" class="button btn">
              <span v-if="loading">
                <loader-icon size="1.5x" class="custom-class"></loader-icon>
                <span style="font-weight: 600; text-transform: initial;">Please Wait</span>
              </span>
              <span v-else>Clear</span>
            </button>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <CDataTable :items="arr" :fields="fields" sorter>
            <template #name="{ item }">
              <td>
                {{ `${item.first_name} ${item.last_name}` }} <br>
                <!-- bagde -->
                <span v-if="item.is_marketer === 'yes'" class="badge badge-success">Marketer</span>
              </td>
            </template>
            <template #roles="{ item }">
              <td>
                <p v-for="(ite, index) in item.roles" :key="index">
                  {{ ite.name }}
                </p>
              </td>
            </template>
            <template #loan_amount_breakdown="{ item }">
              <td>
                <p>0-10K : {{item._0_10k}}</p>
                <p>20K : {{item._15_25K}}</p>
              </td>
            </template>
            <template #loan_status_breakdown="{ item }">
              <td>
                <p>Overdue : {{item.overdue_loan}}</p>
                <p>Active : {{item.active_loans}}</p>                
                <p>Completed : {{item.completed_loans}}</p>                
              </td>
            </template>
            <template #action="{ item }">
              <td class="table--action-mobile">
                <router-link v-if="permissions.includes('view-customer')"
                  :event="permissions.includes('view-customer') ? 'click' : ''" class="button btn-sm w-auto" :class="permissions.includes('view-customer')
                      ? ''
                      : 'disabled cursor-not-allowed'
                    " :to="{
                    name: 'CustomerComponent',
                    params: { slug: item.id }
                  }">
                  View
                </router-link>
                <router-link class="button btn-sm w-auto" :to="{
                  name: 'Referrals',
                  params: { slug: item.id }
                }">
                  View DownLines
                </router-link>
                <button class="button btn-danger btn-sm w-auto" @click="remvoveMarkter(item)">
                  Delete Marketer
                </button>
              </td>
            </template>
          </CDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../services/api.service";
import CDataTable from "../components/CDataTable.vue";
import Swal from "sweetalert2";
const fields = [
  "name",
  "referral_code",
  "referral_count",
  "loan_referral_count",
  "loan_amount_breakdown",
  "loan_status_breakdown",
  "action",
];
export default {
  name: "ReferralStats",
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  components: {
    CDataTable
  },
  data() {
    return {
      loader_message: "Getting Referrals ready...",
      fields,
      loading: true,
      arr: [],
      start_date: "",
      end_date: "",
      name: "",
      data_loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.data_loading = true;
        const res = await ApiService.get(`stats/referrals_by_numbers?start_date=${this.start_date}&end_date=${this.end_date}&name=${this.name}`);
        console.log(res);
        this.arr = res.data.data;
        this.loading = false;
        this.data_loading = false;
      } catch (error) {
        console.log("error.response");
        this.data_loading = false;
      }
    },
    remvoveMarkter(item) {
      Swal.fire({
        title: `Are you sure you want to remove ${item.first_name} ${item.last_name} asa  marketer?`,
        showCancelButton: true,
        confirmButtonText: `Yes, Remove it!`,
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.loader_message = "Removing Marketer...";
            this.loading = true;
            const response = await ApiService.get(
              `customer/remove_customer_as_marketer/${item.id}`
            );   
            this.loading = false;         
            Swal.fire({
              title: "Success",
              text: response.data.message,
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              confirmButtonText: "OK"
            });
            setTimeout(() => {
              this.getData();
            }, 2000);
          } catch (error) {
            this.loading = false;
            console.log(error.response);
            let _error = error.response.data;
            ErrorService.displayErrorAlert(_error);
          }
        }
      });
    },
    clearData() {
      this.start_date = "";
      this.end_date = "";
      this.name = "";
      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped></style>
